import { api } from './api';

export interface TopicLifecycleDTO {
  nodeId: number;
  plannedDate: string | null;
  startedDate: string | null;
  completedDate: string | null;
  state: 'NONE' | 'SCHEDULED' | 'STARTED' | 'COMPLETED';
}

export const getLifecycle = async (courseId: number, nodeId: number): Promise<TopicLifecycleDTO> => {
  const res = await api.get<{ data: TopicLifecycleDTO }>(`/api/tutor/courses/${courseId}/nodes/${nodeId}/lifecycle`);
  return res.data.data;
};

export const setPlannedDate = async (courseId: number, nodeId: number, plannedDate: string): Promise<TopicLifecycleDTO> => {
  const res = await api.put<{ data: TopicLifecycleDTO }>(`/api/tutor/courses/${courseId}/nodes/${nodeId}/lifecycle/planned-date`, { plannedDate });
  return res.data.data;
};

export const clearPlannedDate = async (courseId: number, nodeId: number): Promise<TopicLifecycleDTO> => {
  const res = await api.delete<{ data: TopicLifecycleDTO }>(`/api/tutor/courses/${courseId}/nodes/${nodeId}/lifecycle/planned-date`);
  return res.data.data;
};

export const markStarted = async (courseId: number, nodeId: number): Promise<TopicLifecycleDTO> => {
  const res = await api.post<{ data: TopicLifecycleDTO }>(`/api/tutor/courses/${courseId}/nodes/${nodeId}/lifecycle/start`);
  return res.data.data;
};

export const markCompleted = async (courseId: number, nodeId: number): Promise<TopicLifecycleDTO> => {
  const res = await api.post<{ data: TopicLifecycleDTO }>(`/api/tutor/courses/${courseId}/nodes/${nodeId}/lifecycle/complete`);
  return res.data.data;
};

export const getStudentLifecycle = async (courseId: number, nodeId: number): Promise<TopicLifecycleDTO> => {
  const res = await api.get<{ data: TopicLifecycleDTO }>(`/api/student/courses/${courseId}/topics/${nodeId}/lifecycle`);
  return res.data.data;
};
